import { createFeatureSelector, createSelector } from "@ngrx/store";
import { BreeceSelectorsAdapter } from "./breece-selector.reducers";
import { BreeceSelectorState } from "../../models/state/app-state";
import { memoizeSelector } from "../memoize-selector";

const selectBreeceSelectorState = createFeatureSelector<BreeceSelectorState>('breeceSelectorState');

export const selectAllBreeceSelector = memoizeSelector(() => createSelector(
    selectBreeceSelectorState,
     BreeceSelectorsAdapter.getSelectors().selectAll
));
export const selectBreeceSelector = memoizeSelector((breeceSelectorName: string) => createSelector(
    selectBreeceSelectorState,
    (state) => BreeceSelectorsAdapter.getSelectors().selectAll(state).filter(d => d.enumName == breeceSelectorName)
));
